import { map as rxjsmap } from 'rxjs';

import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import * as _ from 'lodash';
import { ProjectEdit } from '../models/projectEdit';
import { BaseServices } from './../../kuba.services';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class ProjectServices {
  constructor(private http: HttpClient) {}

  getlistByBusiness(id: number) {
    return this.http
      .get(environment.BASE_URL + '/project/getall/' + id).pipe(rxjsmap((res: any) => res));
  }

  getProjectById(id: number) {
    return this.http
      .get(environment.BASE_URL + '/Project/' + id).pipe(rxjsmap((res: any) => res));
  }

  create(newProject: ProjectEdit) {
    return this.http
      .post(environment.BASE_URL + '/project/save', newProject).pipe(rxjsmap(result => result));
  }

  getProjectList(id: number) {
    return this.http
      .get(environment.BASE_URL + '/project/name/' + id).pipe(rxjsmap((result: any) => result));
  }

  getProjectByUser(Id: number, businessId: number) {
    return this.http
      .get(
        environment.BASE_URL +
          '/project/getuserprojects/' +
          Id +
          '/' +
          businessId +
          '/' +
          BaseServices.FeatureId
      ).pipe(rxjsmap((result: any) => result));
  }

  getProjectByGuest(uID: number) {
    return this.http
      .get(environment.BASE_URL + '/project/getGuestprojects/' + uID).pipe(rxjsmap(result => result));
  }


  getSubContractor(id: number) {
    return this.http
      .get(environment.BASE_URL + '/project/ContractorLookup/' + id).pipe(rxjsmap((result: any) => result));
  }

  // contactperson dropdown
  getClientUser(id: number) {
    return this.http
      .get(environment.BASE_URL + '/project/ContactLookup/' + id).pipe(rxjsmap((result: any) => result));
  }

  getUser(id: number) {
    return this.http
      .get(environment.BASE_URL + '/project/ContactLookup/' + id).pipe(rxjsmap((result: any) => result));
  }

  update(ExistingProject: ProjectEdit) {
    return this.http
      .put(environment.BASE_URL + '/project/update', ExistingProject).pipe(rxjsmap(result => result));
  }

  deleteproject(id: number) {
    return this.http
      .delete(environment.BASE_URL + '/project/delete/' + id).pipe(rxjsmap(result => result));
  }

  getResponsibility() {
    return this.http
      .get(environment.BASE_URL + '/project/Responsibility').pipe(rxjsmap((result: any) => result));
  }

  getContractorContactuser(contractorId: any[]) {
    return this.http
      .put(environment.BASE_URL + '/project/contractorcontacts/', contractorId).pipe(rxjsmap(result => result));
  }

  getClientContactUser(clientId: number) {
    return this.http
      .get(
        environment.BASE_URL + '/clientcontact/clientcontactsuser/' + clientId
      ).pipe(rxjsmap(result => result));
  }

  getProjectFeatures(businessId: number) {
    let featureId: number;
    let workingModule = JSON.parse(sessionStorage.getItem('workingModule'));
    featureId = workingModule.id;
    return this.http
      .get(environment.BASE_URL + '/business/' + businessId).pipe(rxjsmap((result: any) => {
        let feature = result.Features;
        let projectAdditionalFeature = _.find(JSON.parse(feature), {
          id: featureId,
          access: true
        });
        return projectAdditionalFeature;
      }));
  }

  getActiveClientContactUser(clientId: number) {
    return this.http
      .get(
        environment.BASE_URL +
          '/clientcontact/activeclientcontactsuser/' +
          clientId
      ).pipe(rxjsmap(result => result));
  }
}
